import React from 'react';
export const AuthStoreContext = React.createContext();
export const UserStoreContext = React.createContext();
export const ShippingItemStoreContext = React.createContext();
